//import axios from "axios/index";
//import api from "../../config/_api";
import { USER_REQUEST, USER_ERROR, USER_SUCCESS,STRUCTURE_CHANGE,UPDATED_PROFILE} from '../actions/user'
//import {AUTH_ERROR, AUTH_LOGOUT, AUTH_SUCCESS} from '../actions/auth'
import {AUTH_LOGOUT, AUTH_STRUCTURE_CHANGE} from '../actions/auth'

import createPersistedState from 'vuex-persistedstate';

const state = { status: '', profile: {}, structure_id: null,structures : "" };


const getters = {
    getProfile: state => state.profile,
    structure_id: state => state.structure_id,
    structures : state => state.structures,
    isProfileLoaded: state => !!state.profile.name,
};

const actions = {
    [USER_REQUEST]: ({commit, dispatch}) => {
        commit(USER_REQUEST);
        if(sessionStorage.getItem('user') != null) {
            commit(USER_SUCCESS, JSON.parse(sessionStorage.getItem('user')));
        } else {
            commit(USER_ERROR);
            // if resp is unauthorized, logout, to
            dispatch(AUTH_LOGOUT)
        }

        /*
        axios({url: api.url + 'users/1?structure_id=1', method: 'GET' })
            .then(resp => {
                commit(USER_SUCCESS, resp)
            })
            .catch(err => {

                // if resp is unauthorized, logout, to
                dispatch(AUTH_LOGOUT)
            }); */
    },
    [STRUCTURE_CHANGE]: ({commit, dispatch}, newValue) => {
        dispatch(AUTH_STRUCTURE_CHANGE,newValue);
        commit('STRUCTURE_CHANGE', newValue.id);
      },
      [UPDATED_PROFILE]: ({commit}, newValue) => {
        commit('UPDATED_PROFILE', newValue);
      },

};

const mutations = {
    [USER_REQUEST]: (state) => {
        state.status = 'loading';
    },
    
    [USER_SUCCESS]: (state, resp) => {
        state.status = 'success';
        state.profile = resp;
        state.structures= state.profile.structures;
        
       // console.log(state.structure_id);
    },
    [USER_ERROR]: (state) => {
        state.status = 'error';
    },
    [AUTH_LOGOUT]: (state) => {
        state.profile = {};
        state.structure_id = null;
    },
    [STRUCTURE_CHANGE]: (state, newValue) => {
        state.structure_id=newValue;
    },
    
    [UPDATED_PROFILE]: (state, newValue) => {
        state.profile=newValue;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}